import React from 'react';
import classNames from 'classnames';
import { Button } from '../../../commonv3/components/atoms/buttons/Button';
import { V3Routes } from '../../routes';
import './lessonHomeworkCompletePane.module.scss';
import { useNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';

export const LessonHomeworkSubmissionCompletePage = () => {
  useNavigation(NavigationSpecs.side());
  return (
    <div styleName="page" id="lesson-homework-submission-complete-page">
      <div styleName="page-inner">
        <div styleName="subtitle-wrapper">
          <div styleName="subtitle">提出が完了しました</div>
        </div>
        <div styleName="header">課題提出お疲れ様でした！</div>
        <div styleName="message">
          今回の課題はいかがでしたか？
          <div styleName="red-message">添削が完了したらメールにてお知らせいたします。</div>
          楽しみに待っていてくださいね。
        </div>
        <div styleName="button-wrapper">
          <Button id="back-to-home-button" type="primary" to={V3Routes.home()} styleName="button">
            ホームに戻る
          </Button>
          <Button
            id="back-to-submission-list-button"
            type="normal"
            styleName="button"
            to={V3Routes.userCourseWorkSubmissions()}
          >
            提出した課題一覧を戻る
          </Button>
        </div>
        <div styleName={classNames('welcome-she-chan')} />
        <div styleName={classNames('letter-image')} />
        <div styleName={classNames('she-pc-image')} />
      </div>
      <div styleName="wakuwaku-background" />
      <div styleName="wakuwaku-background-top" />
    </div>
  );
};
